import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-expansion-panel-header',
    templateUrl: './expansion-panel-header.component.html',
    styleUrls: ['./expansion-panel-header.component.scss'],
    standalone: false
})
export class ExpansionPanelHeaderComponent {
  
  public toggle(event: any): void {
    const panelElementClicked = event.target.closest('.expansion-panel');
    const elementClickedIsOpened = panelElementClicked.classList.contains('expansion-panel-opened');

    this.closePanelOpened();

    if (!elementClickedIsOpened) {
      this.openPanel(panelElementClicked);
    }
  }

  public closePanelOpened(): void {
    const panelOpened = document.querySelector('.expansion-panel-opened');

    if (panelOpened) {
      const panelBody = panelOpened.querySelector('.panel-body');
      const arrowIcon = panelOpened.querySelector('.arrow');

      this.removeClass(panelOpened, 'expansion-panel-opened');
      this.removeClass(panelBody, 'panel-body-opened');
      this.removeClass(arrowIcon, 'arrow-opened');
    }
  }

  public openPanel(expansionPanel: Element): void {
    const bodyPanel = expansionPanel.querySelector('.panel-body');
    const arrowIcon = expansionPanel.querySelector('.arrow');
    
    this.addClass(expansionPanel, 'expansion-panel-opened');
    this.addClass(bodyPanel, 'panel-body-opened');
    this.addClass(arrowIcon, 'arrow-opened');
  }

  public removeClass(el: Element | null, clazz: string): void {
    el?.classList.remove(clazz);
  }

  public addClass(el: Element | null, clazz: string): void {
    el?.classList.add(clazz);
  }
}
